import React from 'react';
import styled from 'styled-components';
import { ModalContext } from '../context/modal';
import * as CONSTANTS from '../constants';
import { logEvent } from '../utils/analytics';

const FilterTitle = styled.li`
  display: block;
  font-size: 13px;
  margin-bottom: 5px;
  font-weight: 200;
`;

const Text = styled.span`
  font-weight: 200;
`;

const filterAreaStyles = `
  padding: 0;
  margin: 0 0 15px 0;
  display: table;
`;

const TagFilters = styled.ul`
  ${filterAreaStyles}
`;

const ShadeFilters = styled.ul`
${filterAreaStyles}
`;

const SocialFilters = styled.ul`
  ${filterAreaStyles}
`;

const Social = styled.a`
    display: flex !important;
    align-items: center;

    float: left;
    font-size: 11px;    
    padding: 3px 10px;
    display: block;
    border-radius: 3px;
    color: ${CONSTANTS.darkGray};
    border: 1px solid ${CONSTANTS.uglyGray};

    ${Text} {
      &:hover {
        color: ${CONSTANTS.mediumGray};
      }
    }
`;

const SocialIcon = styled.svg`
    ${props => 
        props.platform === 'twitter' ? 'margin-right: 6px;' : 
        props.platform === 'facebook' ? 'margin-right: 3px;' : 
        props.platform === 'pinterest' ? 'margin-right: 7px;' : 
        props.platform === 'email' ? 'margin-right: 6px;' : 
        ''
    }
`;

const FilterItem = styled.li`
  float: left;
  margin: 0 10px 10px 0;

  &:last-child {
    margin-right: 0;
  }
`;

const FilterLink = styled.a`
  float: left;
  font-size: 11px;
  font-weight: 200;
  padding: 3px 11px;
  display: block;
  border-radius: 3px;
  color: ${CONSTANTS.darkGray};
  
  ${
    props => (props.tag) ? `
      border: 1px solid ${CONSTANTS.uglyGray};
    ` : ''
  }

  ${
    props => (props.shade) ? `
      border: 1px solid ${CONSTANTS[props.shade]} !important;
    ` : ''
  }

  &.visible {
    color: ${CONSTANTS.white};
    ${
      props => ((props.shade)) ? 
        `
          background-color: ${CONSTANTS[props.shade]};
          color: ${CONSTANTS.white} !important;
        ` : ''
    };

    ${
      props => ((props.tag)) ? 
        `
          background-color: #eee;
          border-color: #eee;
          color: ${CONSTANTS.darkGray};
        ` : ''
    };
  }

  &:hover {
    color: ${CONSTANTS.mediumGray};
  }
`;

const Details = styled.div`
  border: ${props => (props.darkMode === true) ? '1px solid #242329' : '1px solid #eee'};

	padding: 15px 15px 5px 15px;
	border-radius: 3px;
	margin: 45px auto 0 auto;

  ${FilterTitle} {
      ${props => (props.darkMode === true) ? `
      color: ${CONSTANTS.darkModeWhite};
      ` : ''}
  }

  ${Text} {
      ${props => (props.darkMode === true) ? `
      color: ${CONSTANTS.darkModeWhite};
      ` : ''}
  }

  ${FilterLink} {
    ${props => (props.darkMode === true) ? `
      border: 1px solid #242329;
      color: #717171;

      &:hover {
        color: #404040;
      }
    ` : ''}
  }

  ${Social} {
    ${props => (props.darkMode === true) ? `
      border: 1px solid #242329;

      & span {
        color: #717171;

        &:hover {
          color: #404040;
        }
      }
    ` : ''}
  }

  ${SocialIcon} {
    ${props => (props.darkMode === true) ? `
      & path {
        fill: #717171;
      }
    ` : ''}
  }
`;

function socialIframe(url, width, height) {
  var leftPosition, topPosition;
  leftPosition = (window.screen.width / 2) - ((width / 2) + 10);
  topPosition = (window.screen.height / 2) - ((height / 2) + 50);
  window.open(url, "Window2", "status=no,height=" + height + ",width=" + width + ",resizable=yes,left=" + leftPosition + ",top=" + topPosition + ",screenX=" + leftPosition + ",screenY=" + topPosition + ",toolbar=no,menubar=no,scrollbars=no,location=no,directories=no");
} 

export default class Entryinfo extends React.Component {

  constructor(props) {
    super(props);

    this.socialShare = this.socialShare.bind(this);
  }

  socialShare(event, link) {
    event.preventDefault();

    socialIframe(link, 545, 435);  
  }

  render() {

    const { inboundUrl } = this.props;

    const domain = 'https://sitesee.co/'; //window.location.origin;

    const shadesList = this.props.shades.map(shade => {
        return <FilterItem key={`${shade}-details`}><FilterLink href={`/?shades=${shade.trim()}`} onClick={event => logEvent('details filter | add', 'shade')} typeOfFilter="shade" shade={`filter_${shade.trim()}`}>{shade.trim()}</FilterLink></FilterItem>;
    });

    const tagsList = this.props.tags.map(tag => {
        return <FilterItem key={`${tag}-details`}><FilterLink href={`/?tags=${tag.trim()}`} onClick={event => logEvent('details filter | add', 'tag')} typeOfFilter="tag" tag={tag.trim()}>{tag.trim()}</FilterLink></FilterItem>;
    });

    // TODO: add meta tags

    const fbLink = `http://www.facebook.com/sharer.php?u=${domain}${inboundUrl}`;

    const twitterLink = `https://twitter.com/intent/tweet?source=webclient&amp;text=${domain}${inboundUrl}`;

    const pinterestLink = `http://pinterest.com/pin/create/button/?url=${domain}${inboundUrl}`;

    const emailLink = encodeURI(`mailto:?subject=${this.props.title} - featured on SiteSee&body=I thought you might like this site: ${domain}${inboundUrl}`);

    return (
      <Details darkMode={this.context.darkMode}>
        <TagFilters aria-label="Tag filters"><FilterTitle aria-label="Tags title">Tags</FilterTitle> {tagsList}</TagFilters>
        <ShadeFilters aria-label="Shade filters"><FilterTitle aria-label="Shades title">Shades</FilterTitle> {shadesList}</ShadeFilters>
        <SocialFilters aria-label="Social sharing links">
          <FilterTitle aria-label="Share title">Share</FilterTitle>
          <FilterItem><Social href={twitterLink} onClick={event => {this.socialShare(event, twitterLink);logEvent('social share', 'twitter')}}><SocialIcon platform="twitter" xmlns="http://www.w3.org/2000/svg" height="15" viewBox="0 0 24 24"><path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z"></path></SocialIcon> <Text>Twitter</Text></Social></FilterItem>
          <FilterItem><Social href={fbLink} onClick={event => {this.socialShare(event, fbLink);logEvent('social share', 'facebook')}}><SocialIcon platform="facebook" xmlns="http://www.w3.org/2000/svg" height="15" viewBox="0 0 24 24"><path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z"></path></SocialIcon> <Text>Facebook</Text></Social></FilterItem>
          <FilterItem><Social href={pinterestLink} onClick={event => {this.socialShare(event, pinterestLink);logEvent('social share', 'pinterest')}}><SocialIcon platform="pinterest" xmlns="http://www.w3.org/2000/svg" height="15" viewBox="0 0 24 24"><path d="M12 0c-6.627 0-12 5.372-12 12 0 5.084 3.163 9.426 7.627 11.174-.105-.949-.2-2.405.042-3.441.218-.937 1.407-5.965 1.407-5.965s-.359-.719-.359-1.782c0-1.668.967-2.914 2.171-2.914 1.023 0 1.518.769 1.518 1.69 0 1.029-.655 2.568-.994 3.995-.283 1.194.599 2.169 1.777 2.169 2.133 0 3.772-2.249 3.772-5.495 0-2.873-2.064-4.882-5.012-4.882-3.414 0-5.418 2.561-5.418 5.207 0 1.031.397 2.138.893 2.738.098.119.112.224.083.345l-.333 1.36c-.053.22-.174.267-.402.161-1.499-.698-2.436-2.889-2.436-4.649 0-3.785 2.75-7.262 7.929-7.262 4.163 0 7.398 2.967 7.398 6.931 0 4.136-2.607 7.464-6.227 7.464-1.216 0-2.359-.631-2.75-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146 1.124.347 2.317.535 3.554.535 6.627 0 12-5.373 12-12 0-6.628-5.373-12-12-12z" fillRule="evenodd" clipRule="evenodd"></path></SocialIcon> <Text>Pinterest</Text></Social></FilterItem>
          <FilterItem><Social href={emailLink} onClick={event => {this.socialShare(event, emailLink);logEvent('social share', 'email')}}><SocialIcon platform="email" xmlns="http://www.w3.org/2000/svg" height="15" viewBox="0 0 24 24"><path d="M0 3v18h24v-18h-24zm21.518 2l-9.518 7.713-9.518-7.713h19.036zm-19.518 14v-11.817l10 8.104 10-8.104v11.817h-20z"></path></SocialIcon> <Text>Email</Text></Social></FilterItem>
        </SocialFilters>
      </Details>
    );
  }
}

Entryinfo.contextType = ModalContext;
